import styled from 'styled-components';

import { StyledNav, StyledNavContainer } from '../Header/styled';

export const StyledB2BNavContainer = styled(StyledNavContainer)``;

export const StyledB2BNav = styled(StyledNav)`
  @media (min-width: ${props => props.theme.screen.md}) {
    border-color: ${props => props.theme.colors.secondary};
    background-color: ${props => props.background};
    }};
  }
`;
